import React, { type FC } from 'react'

import classes from './StartTimeInfo.module.scss'
import dayjs from 'dayjs'

type StartTimeInfoProps = {
  startTime?: string | number
}

export const StartTimeInfo: FC<StartTimeInfoProps> = ({ startTime = 0 }) => {
  const date = dayjs.unix(+startTime)

  const formattedDate = date.format('ddd, DD MMM')

  const formattedTime = date.format('HH:mm')

  return (
    <div className={classes.Date}>
      <div>{`${formattedDate} | ${formattedTime}`}</div>
    </div>
  )
}
